import {Pipe, PipeTransform} from '@angular/core';
import {ACTIVITY_STATUS} from '../abp-tabs.constants';

@Pipe({
  name: 'getStatus',
})
export class GetStatusPipe implements PipeTransform {
  activityStatus: typeof ACTIVITY_STATUS = ACTIVITY_STATUS;

  transform(status: string): string {
    if (!status) {
      return '';
    }

    // Handle new API status format (e.g., "PENDING_REVIEW", "PUBLISHED", etc.)
    const newStatusMap: { [key: string]: string } = {
      'PENDING_REVIEW': 'PENDING REVIEW',
      'PUBLISHED': 'PUBLISHED',
      'REJECTED': 'REJECTED',
      'SCHEDULED': 'SCHEDULED',
      'ACTIVE': 'ACTIVE',
      'LIVE': 'LIVE',
      'INACTIVE': 'INACTIVE',
      'UNPUBLISHED': 'UNPUBLISHED',
      'DRAFT': 'DRAFT',
      'SUSPENDED': 'Suspended',
    };

    // Check if it's a new status format
    if (newStatusMap[status]) {
      return newStatusMap[status];
    }

    // Handle old status format (enum values)
    const returnStr =
      Object.keys(ACTIVITY_STATUS)[Object.values(ACTIVITY_STATUS).indexOf(status as unknown as ACTIVITY_STATUS)];
    
    if (!returnStr) {
      // If not found in enum, return the status as-is (formatted)
      return status.split('_').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      ).join(' ');
    }

    switch (returnStr) {
      case 'DELETE_SCHEDULED':
      case 'DELETE_PROCESSING':
        return 'DELETING';
      case 'UNPUBLISH_SCHEDULED':
      case 'UNPUBLISH_PROCESSING':
        return 'UNPUBLISHING';
      case 'PROCESSING':
        return 'PUBLISHING';
      default:
        return returnStr;
    }
  }
}
